import React from "react";
import { Fab, Tooltip } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";

export default function PATReopenButton(props) {
	const { onClick, disabled, size, tooltipText } = props;

	return (
		<Tooltip title={tooltipText || "Reopen"}>
			<Fab
				size="small"
				disabled={disabled}
				color="secondary"
				aria-label="reopen"
				className={props.className ? props.className : ""}
				onClick={onClick}
			>
				<ReplayIcon style={{ fontSize: size }} />
			</Fab>
		</Tooltip>
	);
}
